export const MUTATIONS_TYPES = {
    SET_STEP: 'set step',
    SET_SELECTED_ISSUES: 'set selected issues',
    SET_SELECTED_ISSUE: 'select issue',
    SET_RECOMMENDATION: 'set recommendation',
    SET_TOPLINE: 'set topline',
    SET_SHARE_POPUP_STATE: 'set share popup state'
};
